module.exports = __webpack_public_path__ + "media/images/upload_5-891e1651.png";